export const LoadingEase = ({forceStyles, children}) => {
  return (
    <div className="ease-animation" style={{...styles.loading, ...forceStyles}}>
      {children}
    </div>
  )
}

const styles = {
  loading: {
    padding: "12px 0",
    fontSize: "12px",
    color: "#666666"
  }
}